import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Image from "mui-image";
import logo from "../../../assets/download.svg";
import dmca from "../../../assets/dmca-badge.png";
import footerlogo from "../../../assets/foot-clutch-logo.svg";
import footerlogo2 from "../../../assets/foot-foodfirms-logo.svg";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

type IMenuItem = {
  heading: string;
  menu: string[];
};

const menuItems: IMenuItem[] = [
  {
    heading: "About Simform",
    menu: [
      "About Us",
      "our partner",
      "How Simform Works",
      "areas we serve",
      "career",
      "contact us",
    ],
  },
  {
    heading: "Services",
    menu: [
      "Product Enginnering",
      "cloud and devops engineering",
      "data engineering",
      "quality engineering",
      "talent solutino",
    ],
  },
  {
    heading: "resources",
    menu: ["blog", "ebooks", "case studies"],
  },
];

const FooterMenu = () => {
  return (
    <section id="footer" style={{ backgroundColor: "#FBFBFE" }}>
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "160px 0" } }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container sx={{ padding: { xs: "0 13px" } }}>
            <Grid item xs={12} md={3}>
              <Grid
                container
                spacing={2}
                sx={{
                  padding: { xs: "9px 0", sm: "9px 0", md: "0 0" },
                  alignItems: "center",
                  justifyContent: { xs: "space-between" },
                }}
              >
                <Grid item className="xs-none" sm={4} md={12}>
                  <Image
                    style={{ marginRight: 0 }}
                    src={logo}
                    alt="logo"
                    width="161px"
                    height="30px"
                    className="footerLogo"
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={12}>
                  <Link to="/" style={{ color: "#969696", marginRight: "5px" }}>
                    <FacebookIcon />
                  </Link>
                  <Link to="/" style={{ color: "#969696", marginRight: "5px" }}>
                    <LinkedInIcon />
                  </Link>
                  <Link to="/" style={{ color: "#969696", marginRight: "5px" }}>
                    <TwitterIcon />
                  </Link>
                  <Link to="/" style={{ color: "#969696" }}>
                    <YouTubeIcon />
                  </Link>
                </Grid>
                <Grid item xs={12} sm={4} md={12}>
                  <Box
                    sx={{
                      background: "rgb(244, 244, 244)",
                      border: " 0.8px solid rgb(220, 218, 218)",
                      borderRadius: "3px",
                      padding: "14px 15px",
                      maxWidth: "189px",
                      alignItems: "center",
                    }}
                  >
                    <img
                      style={{
                        //   marginRight: 0,
                        borderRight: "0.8px solid rgb(220, 218, 218)",
                        paddingRight: "15px",
                      }}
                      src={footerlogo}
                      alt="footerlogo"
                      height="36px"
                      width="55px"
                    />
                    <img
                      src={footerlogo2}
                      alt="footerlogo"
                      width="82px"
                      height="33px"
                      style={{ marginLeft: "12px" }}
                    />
                  </Box>
                  <Box>
                    <img
                      src={dmca}
                      alt="dmcalogo"
                      width="100px"
                      height="auto"
                      style={{ marginTop: "15px", marginBottom: "19px" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {menuItems.map((menu, i) => (
                  <Grid item key={i} xs={12} sm={4} md={4}>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        borderBottom: "1px solid rgba(197, 197, 197, 0.45)",
                      }}
                    >
                      {menu.heading}
                    </Typography>
                    <Box
                      sx={{ display: { xs: "flex" }, flexWrap: { xs: "wrap" } }}
                    >
                      {menu.menu.map((item, i) => (
                        <Typography
                          variant="subtitle1"
                          component="p"
                          gutterBottom
                          align="left"
                          key={i}
                          sx={{ padding: { xs: "7px 10px 7px 0" } }}
                        >
                          <Link
                            style={{
                              textDecoration: "none",
                              color: "rgb(61, 61, 61)",
                            }}
                            to={`/${item}`}
                          >
                            {item}
                          </Link>
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default FooterMenu;
